<div class="cell-name bold uppercase" [tiimeTooltip]="company.name" tooltipHideWithoutEllipsis>
  {{ company.name }}
</div>
@if (company | companyInfosLabel: taxRegimes : additionalInfo; as cellInfos) {
  <div class="cell-infos" [tiimeTooltip]="cellInfos" tooltipHideWithoutEllipsis>
    {{ cellInfos }}
  </div>
}
